import * as React from 'react';
import styled from 'styled-components';

import Icon from '../Icon';

type ListItem = {
  value: string;
  icon: string;
  header?: string;
  amount?: string;
  percent?: string;
  number?: number;
};

type Props = {
  variant: string;
  items: ListItem[];
};

const Header = styled.p<{ main: boolean }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: '0 0 0 32px', // account for icon
  opacity: 0.5,
  color: theme.grey03,
  fontSize: '14px',
  letterSpacing: '0.17px',
  lineHeight: '19px',

  '@media screen and (min-width: 768px)': {
    fontSize: '16px',
    margin: '0 0 4px 36px', // account for icon
  },
}));

const Item = styled.div<{ main: boolean }>(({ main, theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',

  '& > p': {
    fontSize: main ? '18px' : '13px',
    lineHeight: main ? '28px' : '24px',
    letterSpacing: main ? '.09px' : '.14px',
    opacity: main ? 0.9 : 0.6,
    color: theme.white,
    margin: '0 0 0 8px',
  },

  '@media screen and (min-width: 768px)': {
    alignItems: 'center',
    '& > p': {
      fontSize: main ? '24px' : '13px',
      lineHeight: main ? '28px' : '24px',
      letterSpacing: main ? '.26px' : '.14px',
      margin: '0 0 0 12px',
    },
  },
}));

const ListItem = styled.li<{ main: boolean }>(({ main }) => ({
  marginBottom: main ? '12px' : '8px',
  listStyle: 'none',

  '&:last-of-type': {
    marginBottom: 0,
  },

  '@media screen and (min-width: 768px)': {
    marginBottom: main ? '16px' : '8px',
  },
}));

const ListRoot = styled.ul({
  paddingLeft: '8px',
  margin: 0,
});

const List: React.FC<Props> = ({ variant, items }) => {
  const isMainList = variant === 'main';
  return (
    <ListRoot>
      {items.map(({ value, icon, header, amount, percent, number }, index) => {
        let parsedString = value;
        if (amount && /{amount}/.test(parsedString)) {
          parsedString = parsedString.replace(/{amount}/, amount);
        }
        if (percent && /{percent}/.test(parsedString)) {
          parsedString = parsedString.replace(/{percent}/, percent);
        }
        if (number && /{number}/.test(parsedString)) {
          parsedString = parsedString.replace(/{number}/, `${number}`);
        }

        return (
          <ListItem key={`${value}${icon}${index}`} main={isMainList}>
            {header && <Header main={isMainList}>{header}</Header>}
            <Item main={isMainList}>
              <Icon
                name={icon}
                hasBackground={!isMainList && icon !== 'germany'}
              />
              <p>{parsedString}</p>
            </Item>
          </ListItem>
        );
      })}
    </ListRoot>
  );
};

export default List;
